import { render, staticRenderFns } from "./FileThumbIcon.vue?vue&type=template&id=6e4efcfe"
import script from "./FileThumbIcon.vue?vue&type=script&lang=js"
export * from "./FileThumbIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports